import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import "./INTERIOR_DESIGN_TEMPLATE.css";
import { Api } from "../../../services/api";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import { InteriorDesignTemplate } from "../../../services/Template/interior-design-template";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useParams } from 'react-router-dom';
import { FaCopy, FaPlus, FaTrash } from 'react-icons/fa';
// import { useScreenshot } from 'use-react-screenshot'
// import html2canvas from 'html2canvas';
import { toPng } from 'html-to-image';
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { BsFillInfoCircleFill } from "react-icons/bs";

const EDIT_INTERIOR_DESIGN_TEMPLATE = ({ pmId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isCopyBtnLoading, setIsCopyBtnLoading] = useState(false);


  const ref = useRef(null)
  const ref2 = useRef(null)

  const [projectData, setProjectData] = useState([]);
  const navigate = useNavigate();
  const { editId } = useParams();
  const toast = useRef(null);

  const adjustTextareaHeight = (textarea) => {
    textarea.style.height = 'auto'; // Reset the height
    textarea.style.height = textarea.scrollHeight + 'px'; // Set the height to the scroll height
  };

  const expandAllTextareas = () => {
    elementRefs.forEach(ref => {
      if (ref.current) {
        const textareas = ref.current.querySelectorAll('textarea');
        textareas.forEach(adjustTextareaHeight);
      }
    });
  };

  const formik = useFormik({
    initialValues: InteriorDesignTemplate.getFormName(),
    validate: (data) => {

    },

    onSubmit: (data) => {
      if (!existPageWithoutSave) {
        return;

      }

      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };

      data.user_id = localStorage.getItem('user_id');
      data.role_id = localStorage.getItem('role_id');
      var url = Api.API_BASE_URL + 'interior/save';



      // var url = Api.API_BASE_URL + 'interior-template/update/' + editId;


      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          setExistPageWithoutSave(false);
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

          } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });



    }
  });

  const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

  useEffect(() => {

    getDetailsInterioDesign(pmId);

    return () => {
      // Cleanup tasks before the component is unmounted
      // if (existPageWithoutSave) {
      // if (window.confirm('Do you want to save changes you made to this document?')) {
      formik.handleSubmit();
      // }
      // }
    };
  }, [pmId,]);

  const [preConstructionShedule, setPreConstructionShedule] = useState([1]);
  const handleAddInputForPreConstructionShedule = () => {
    setPreConstructionShedule([...preConstructionShedule, 1]);
    var t = {
      genrealProjectCheckListTitle: "",
      misc1: "",
      miscReason: '',
    };
    formik.values.section_10.push(t);

  };

  const handleDeleteInputForreConstructionShedule = (index) => {
    setPreConstructionShedule([...preConstructionShedule, 2]);
    var newArray = [...preConstructionShedule];
    newArray.splice(index, 1);
    formik.values.section_10.splice(index, 1);
    setPreConstructionShedule(newArray);
  };

  const getDetailsInterioDesign = (id) => {
    // interior-template/get-interior/{editId}
    formik.setFieldValue('project_id', id);
    var _body = {
      projectId: id,
    }
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'interior/get', {
      method: "POST",
      headers: headers,

      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);

        if (response.error != '') {

          formik.setFieldValue('interior_id', 0);
        } else {
          formik.setFieldValue('project_id', response.project_id);
          formik.setFieldValue('interior_id', response.interior_id);
          InteriorDesignTemplate.section_1_List().forEach(element => {
            formik.setFieldValue(element, response.sec_1[element]);
          });

          InteriorDesignTemplate.section_2_List().forEach(element => {
            formik.setFieldValue(element, response.sec_2[element]);
          }); InteriorDesignTemplate.section_3_List().forEach(element => {
            formik.setFieldValue(element, response.sec_3[element]);
          });



          if (response.sec_4.length != 0) {
            formik.setFieldValue(`section_4`, response.sec_4);
          }
          if (response.sec_5.length != 0) {
            formik.setFieldValue(`section_5`, response.sec_5);
          }
          if (response.sec_6.length != 0) {
            formik.setFieldValue(`section_6`, response.sec_6);
          }
          if (response.sec_7.length != 0) {
            formik.setFieldValue(`section_7`, response.sec_7);
          }
          if (response.sec_8.length != 0) {
            formik.setFieldValue(`section_8`, response.sec_8);
          }



          if (response.sec_9.length != 0) {
            formik.setFieldValue(`section_9`, response.sec_9);
          }
          if (response.sec_10.length != 0) {
            formik.setFieldValue(`section_10`, response.sec_10);
            var t = [];
            response.sec_10.forEach(element => {
              t.push(0)
            });
            setPreConstructionShedule(t);
          }


          formik.setFieldValue('project_id', response.project_id);
          formik.setFieldValue('interior_id', response.interior_id);

        }

        setIsLoading(false);

      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  }



  //? ________________________________

  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    // textAlign: 'center',
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    backgroundColor: 'white',
    paddingTop: '5px'
  };

  const yesCellStyle = {
    ...cellStyleW,
    // background: "#FEC025",
  };



  const firstColumnWidth = {
    width: "80px", // Adjust the width as needed
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
    // Remove padding to fit the dropdown
  };

  //? --------------------------------------

  //! ________________________________
  const renderTextArea = (fieldName, placeholder, formdata = '', maxLine = 2) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      rows={maxLine}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
    ></textarea>
  );

  const renderTextAreaFull = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      autoResize
      id={fieldName}
      rows={maxLine}
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        console.log(e.target.value)
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', }}
    ></InputTextarea>
  );

  const renderInputArea = (fieldName, placeholder, type = 'text', formdata = '') => {
    if (type == 'date') {

      if (formdata != null) {
        let timestamp = new Date(formdata);

        if (!isNaN(timestamp.getTime())) {
          formdata = timestamp.toISOString().split('T')[0];
        }
      }
    }
    return (
      <input
        type={type}
        placeholder={placeholder}
        name={fieldName}
        id={fieldName}
        value={formdata !== '' ? formdata : formik.values[fieldName]}
        // onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission on Enter key press
          }
        }}
        style={{
          width: '100%',
          height: '40px',
          boxSizing: 'border-box',
          border: 'none',
          textAlign: 'center',
          marginTop: '0px',
        }}
      />
    );
  }

  const renderInputAreaForAmount = (fieldName, formData = '') => (
    <InputNumber
      inputId="currency-us"
      value={formData != '' ? formData : formik.values[fieldName]}
      // value={formdata !== '' ? formdata : formik.values[fieldName]}
      className="text-center"
      inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
      placeholder="$0.00"
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      mode="currency"
      currency="USD"
      locale="en-US"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center !important",
        marginTop: "0px",
        outline: 'none',
      }}
    />
  );

  const renderPercentageInputArea = (fieldName, formData = '') => (
    <InputNumber

      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center"
      inputClassName={Number(formik.values[fieldName]) < 0 ? "is-negative" : "is-positive"}
      placeholder="0.00"
      maxFractionDigits={2}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      suffix="%"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center !important",
        marginTop: "0px",
      }}
    />
  );

  const renderSelect = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];
    console.log('val', val);

    return <select
      name={fieldName}
      id={fieldName}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      className={'select-text-color-' + val}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center',  color: 'white', backgroundColor: '#ff0000', border: 'none' }}
    >
      <option value="N">No</option>
      <option value="Y">Yes</option>
      <option value="NA">N/A</option>
    </select>

  };


  const renderSelect1 = (fieldName, formdata = '') => {


    return (
      <select
        name={fieldName}
        id={fieldName}
        value={formdata !== '' ? formdata : formik.values[fieldName]}
        className={'select-text-color-' + formik.values[fieldName]}
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
      >
        <option value="N">No</option>
        <option value="Y">Yes</option>
        {/* <option value="NA">NA</option> */}
      </select>
    );
  };





  //! -----------------------------------------------

  //? ------------------------------------------------
  const section_1_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "250px" }}>{title}</td>

        {/* <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputAreaForAmount(fieldName_1, '', 'number')}</td> */}
        {title === 'GP%:' ? null : (
        <td style={{ ...cellStyleW, minWidth: "150px" }}>
          {renderInputAreaForAmount(fieldName_1, '', 'number')}
        </td>
      )}
        <td style={{ ...cellStyleW, minWidth: "250px" }}>{renderTextAreaFull(fieldName_2, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderPercentageInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_4, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_5, '',)}</td>
      </tr>
    );
  }

  const section_2_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "300px" }}>{title}</td>

        <td style={{ ...dropdownCellStyle, width: '100px', height: '32px', }}>
          {renderSelect1(fieldName_1)}
        </td>
        <td style={{ ...cellStyleW, minWidth: "350px" }}>{renderTextAreaFull(fieldName_2, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_4, '', '')}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_5, '', '')}</td>
      </tr>
    );
  }


  //? ------------------------------------------------

  const copyImageToClipboard = (blob) => {
    // Check if Clipboard API is available
    if (navigator.clipboard && navigator.clipboard.write) {
      navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob
        })
      ]).then(() => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
        console.log('Image copied to clipboard');
      }).catch((error) => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
        console.error('Error copying image to clipboard:', error);
      });
    } else {
      setIsCopyBtnLoading(false);
      console.error('Clipboard API not available');
    }
  };
  const elementRefs = [
    useRef(null),
  ];



  const takeScreenshotAndCopy = async () => {
    setIsCopyBtnLoading(true);
    console.log('Take screenshot and copy to clipboard');

    try {
      expandAllTextareas();

      const canvasPromises = elementRefs.map(async (ref) => {
        if (ref.current) {
          return await toPng(ref.current, {
            cacheBust: true,
            pixelRatio: 2,
          });
        }
        return null;
      });

      const images = await Promise.all(canvasPromises);

      // Create a new canvas to combine screenshots
      const combinedCanvas = document.createElement('canvas');
      const context = combinedCanvas.getContext('2d');

      // Calculate total height of combined screenshots
      let totalHeight = 0;
      let maxWidth = 0;
      for (const imgSrc of images) {
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            totalHeight += img.height;
            if (img.width > maxWidth) maxWidth = img.width;
            resolve();
          };
        });
      }

      combinedCanvas.width = maxWidth;
      combinedCanvas.height = totalHeight;

      let offsetY = 0;
      for (const imgSrc of images) {
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            context.drawImage(img, 0, offsetY);
            offsetY += img.height;
            resolve();
          };
        });
      }

      // Convert the combined canvas to a data URL
      combinedCanvas.toBlob(blob => {
        if (blob) {
          copyImageToClipboard(blob);
        } else {
          console.error('Error creating blob');
        }
      }, 'image/png');

    } catch (error) {
      setIsCopyBtnLoading(false);
      console.error('Error taking screenshots:', error);
    }
  };

  //* -------------------------


  return (
    <>
      <Toast ref={toast} />
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (
        <form onSubmit={formik.handleSubmit} className="interior-template-form">
          <div className="flex justify-content-end submitbutton">
            <Button className="m-2 mx-4 p-2 px-3 copySave-button" loading={isCopyBtnLoading} type="button" title="Copy Client Weekly Update" onClick={takeScreenshotAndCopy} >
              <strong className="mr-2">Copy weekly update</strong>
              <FaCopy />
            </Button>
            {/* <Button type="button" label="Back" className="m-2 p-2 mb-0" onClick={goBack} style={{ backgroundColor: 'gray' }} /> */}
            <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center customSave-button" type="submit">
              <strong className="mr-2">Save</strong>
              <i className="pi pi-save"></i>
            </Button>
          </div>



          <div className="cardd" style={{ border: 'none', }} >
            <Accordion multiple activeIndex={[0, 1, 2, 3]}>

              <AccordionTab header="ACTION STEPS">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "300px" }} >
                          Action Steps
                        </th>
                        <th style={{ ...headerStyle, minWidth: "250px" }} colSpan={3} >
                          Address:
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto", }} rowSpan={2}  >
                          Interior Designer Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} rowSpan={2} >
                          Vp Construction Ops Comments Only
                        </th>
                      </tr>
                      <tr>
                        <th style={{ ...headerStyle, }} >
                        </th>
                        <th style={{ ...headerStyle, }} >
                          Total
                        </th>
                        <th style={{ ...headerStyle, }} >
                          Comments
                        </th>
                        <th style={{ ...headerStyle, }} >
                          % Complete
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {section_1_body('ID Contract Amount:', 'IDContractAmountTotal', 'IDContractAmountComments', 'IDContractAmountPerComplete', 'IDContractAmountInterior', 'IDContractAmountVPC')}
                      {section_1_body('Amount Used:', 'AmountUsedTotal', 'AmountUsedComments', 'AmountUsedPerComplete', 'AmountUsedinterior', 'AmountUsedVPC')}
                      {section_1_body('GP%:', 'GpPerTotal', 'GpPerComments', 'GpPerComplete', 'GpPerInterior', 'GpPerVPC')}
                    </tbody>
                  </table>
                </div>

              </AccordionTab>

              <AccordionTab header="DELIVERABLES" className="mt-2">

                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>

                      <tr>
                        <th style={{ ...headerStyle, width: "300px", }} >
                          Deliverables
                        </th>

                        <th style={{ ...headerStyle, width: "100px", }} >
                          Complete Yes/No
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Interior Designer Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Vp Construction Ops Comments
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {section_2_body('Project Preference Sheet Complete', 'ProjectPreferenceComplete', 'ProjectPreferenceComments', 'ProjectPreferencePerComplete', 'ProjectPreferenceInterior', 'ProjectPreferenceVPC')}

                      {section_2_body('RFI\'s up to Date?', 'RFIComplete', 'RFIComments', 'RFIPerComplete', 'RFIInterior', 'RFIVPC')}

                      {section_2_body('Drawings up to date?', 'DrawingsComplete', 'DrawingsComments', 'DrawingsPerComplete', 'Drawingsinterior', 'DrawingsVPC')}

                      {section_2_body('Selection Choices up to date?', 'SelectionsComplete', 'SelectionsComments', 'SelectionsPerComplete', 'SelectionsInterior', 'SelectionsVPC')}

                      {section_2_body('Floor Plans (Concept) - Reno Only', 'FLoorPlanComplete', 'FLoorPlanComments', 'FLoorPlanPerComplete', 'FLoorPlanInterior', 'FLoorPlanVPC')}

                    </tbody>
                  </table>
                </div>

              </AccordionTab>

              <AccordionTab header=" WEEKLY INTERIOR DESIGN UPDATE" className="mt-2">

                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>

                  <table style={{ borderCollapse: "collapse" }}>

                    <thead>

                      <tr>
                        <th style={{ ...headerStyle, minWidth: "auto", }} >
                          Weekly Interior Design Update
                        </th>

                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Vp Construction Ops Comments
                        </th>
                      </tr>

                    </thead>

                    <tbody>
                      <tr>
                        <td style={{ minWidth: '50vw', display: 'flex', alignItems: 'center',  }}>
                              <td style={{ width: '100px' }}>Dear:  </td>
                          {renderTextArea('dear', '',)}

                        </td>

                        <td style={{ ...cellStyleW, minWidth: "530px", }} rowSpan={3}>
                          {renderTextAreaFull('dearVPCComments', '', '', 6)}
                        </td>

                      </tr>
                      <tr>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                          Here Is Your Weekly Summary:
                          <sup> <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='The date is updated automatically every week when it is archived.' /></sup>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                          </div>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>From</div>
                            <input
                              type="date"
                              name="summaryFrom"
                              id="summaryFrom"
                              // value={formik.values['summaryFrom']}
                              value={formik.values.summaryFrom == null ? formik.values.summaryFrom : !isNaN(new Date(formik.values.summaryFrom).getTime()) ? new Date(formik.values.summaryFrom).toISOString().split('T')[0] : formik.values.summaryFrom
                              }
                              onChange={(e) => formik.setFieldValue('summaryFrom', e.target.value)}
                              style={{ width: '100%', textAlign: 'center', height: '32px', color: '#495057', }}

                            />
                          </div>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>To:</div>
                            <input
                              type="date"
                              name="summaryTo"
                              id="summaryTo"
                              // value={formik.values['summaryTo']}
                              value={formik.values.summaryTo == null ? formik.values.summaryTo : !isNaN(new Date(formik.values.summaryTo).getTime()) ? new Date(formik.values.summaryTo).toISOString().split('T')[0] : formik.values.summaryTo
                              }
                              onChange={(e) => formik.setFieldValue('summaryTo', e.target.value)}
                              style={{ width: '100%', textAlign: 'center',  height: '32px', color: '#495057', }}
                            />
                          </div>

                        </td>
                      </tr>
                    </tbody>
                  </table>


                  <table style={{ borderCollapse: "collapse", marginTop: '20px' }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "300px", }} >
                          ID Documents
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Area
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Selections
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }} >
                          Completed Yes/No/NA
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Interior Designer Comments
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }} >
                          ID Bid Req
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }} >
                          PO
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          PO or Drawing Due Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Vp Construction Ops Comments
                        </th>


                      </tr>
                    </thead>

                    <tbody>

                      {InteriorDesignTemplate.getFormName().section_4.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={4}> Pre Start</td>
                            <td style={{ ...cellStyle }} rowSpan={4} >  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_4.${index}.completed`, formik.values.section_4[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.interiorDesignerComments`, ' ', formik.values.section_4[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '100px', height: '32px', }}>  {renderSelect(`section_4.${index}.idBidReq`, formik.values.section_4[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_4.${index}.pO`, formik.values.section_4[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date', formik.values.section_4[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.vPSComments`, ' ', formik.values.section_4[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_4.${index}.completed`, formik.values.section_4[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.interiorDesignerComments`, '', formik.values.section_4[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_4.${index}.idBidReq`, formik.values.section_4[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_4.${index}.pO`, formik.values.section_4[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date', formik.values.section_4[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.vPSComments`, '', formik.values.section_4[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      {/* SCHEDULES  EXTERIOR  Start */}
                      {InteriorDesignTemplate.getFormName().section_5.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={14}> Schedules</td>
                            <td style={{ ...cellStyle }} rowSpan={3} > EXTERIOR  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.completed`, formik.values.section_5[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.interiorDesignerComments`, '', formik.values.section_5[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.idBidReq`, formik.values.section_5[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_5.${index}.pO`, formik.values.section_5[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date', formik.values.section_5[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.vPSComments`, '', formik.values.section_5[index].vPSComments)} </td>

                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.completed`, formik.values.section_5[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.interiorDesignerComments`, '', formik.values.section_5[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.idBidReq`, formik.values.section_5[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_5.${index}.pO`, formik.values.section_5[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date', formik.values.section_5[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.vPSComments`, '', formik.values.section_5[index].vPSComments)} </td>

                            </tr>
                          )
                        )
                      })

                      }

                      {/* SCHEDULES  EXTERIOR  End */}
                      {/* SCHEDULES  INTERIOR  start */}
                      {InteriorDesignTemplate.getFormName().section_6.map((item, index) => {
                        return (
                          index == 0 ? (<tr>

                            <td style={{ ...cellStyle }} rowSpan={11} > INTERIOR  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.completed`, formik.values.section_6[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.interiorDesignerComments`, '', formik.values.section_6[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.idBidReq`, formik.values.section_6[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.pO`, formik.values.section_6[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date', formik.values.section_6[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.vPSComments`, '', formik.values.section_6[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.completed`, formik.values.section_6[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.interiorDesignerComments`, '', formik.values.section_6[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.idBidReq`, formik.values.section_6[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_6.${index}.pO`, formik.values.section_6[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date', formik.values.section_6[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.vPSComments`, ' ', formik.values.section_6[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      {/* SCHEDULES  INTERIOR  End */}


                      {/* DRAWINGS  EXTERIOR  Start */}
                      {InteriorDesignTemplate.getFormName().section_7.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={15}> Drawings</td>
                            <td style={{ ...cellStyle }} rowSpan={3} > EXTERIOR  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_7.${index}.completed`, formik.values.section_7[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_7.${index}.interiorDesignerComments`, ' ', formik.values.section_7[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_7.${index}.idBidReq`, formik.values.section_7[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_7.${index}.pO`, formik.values.section_7[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_7.${index}.poOrDDue`, '', 'date', formik.values.section_7[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_7.${index}.vPSComments`, ' ', formik.values.section_7[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_7.${index}.completed`, formik.values.section_7[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_7.${index}.interiorDesignerComments`, ' ', formik.values.section_7[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_7.${index}.idBidReq`, formik.values.section_7[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_7.${index}.pO`, formik.values.section_7[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_7.${index}.poOrDDue`, '', 'date', formik.values.section_7[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_7.${index}.vPSComments`, ' ', formik.values.section_7[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }

                      {/* DRAWINGS  EXTERIOR  End */}

                      {/* DRAWINGS  INTERIOR  start */}
                      {InteriorDesignTemplate.getFormName().section_8.map((item, index) => {
                        return (
                          index == 0 ? (<tr>

                            <td style={{ ...cellStyle }} rowSpan={12} > INTERIOR  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.completed`, formik.values.section_8[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.interiorDesignerComments`, ' ', formik.values.section_8[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.idBidReq`, formik.values.section_8[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_8.${index}.pO`, formik.values.section_8[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date', formik.values.section_8[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.vPSComments`, ' ', formik.values.section_8[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.completed`, formik.values.section_8[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.interiorDesignerComments`, ' ', formik.values.section_8[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.idBidReq`, formik.values.section_8[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_8.${index}.pO`, formik.values.section_8[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date', formik.values.section_8[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.vPSComments`, ' ', formik.values.section_8[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      {/* DRAWINGS  INTERIOR  End */}

                      {InteriorDesignTemplate.getFormName().section_9.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={6}> Site Inspections Complete</td>
                            <td style={{ ...cellStyle }} rowSpan={6} >  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.completed`, formik.values.section_9[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.interiorDesignerComments`, ' ', formik.values.section_9[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.idBidReq`, formik.values.section_9[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_9.${index}.pO`, formik.values.section_9[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date', formik.values.section_9[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.vPSComments`, ' ', formik.values.section_9[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.completed`, formik.values.section_9[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.interiorDesignerComments`, ' ', formik.values.section_9[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.idBidReq`, formik.values.section_9[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_9.${index}.pO`, formik.values.section_9[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date', formik.values.section_9[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.vPSComments`, ' ', formik.values.section_9[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      <tr>
                        <td>Risk/Safety/Client/Team/Other?</td>
                        <td style={{ ...cellStyleW, }} colSpan={8}>  {renderTextAreaFull('riskSafety', '')} </td>
                      </tr>
                    </tbody>
                  </table>

                </div>

              </AccordionTab>

              <AccordionTab header="GENERAL PROJECT CHECK LIST" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse" }}>
                    <thead style={{ overflowX: "auto" }}>
                      <tr>
                        <th style={{ ...headerStyle, }} >
                          General projects checklist:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {preConstructionShedule.map((item, index) => {
                        return (
                          <tr>
                            <td >
                              <td style={{ ...cellStyleW, width: "300px", }}>
                                {renderInputArea('section_10.' + index + '.genrealProjectCheckListTitle', '', '', formik.values.section_10[index].genrealProjectCheckListTitle)}
                              </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>
                                {renderSelect('section_10.' + index + '.misc1', formik.values.section_10[index].misc1)}
                              </td>
                              <td style={{ ...cellStyleW, width: '70vw' }}>
                                {renderTextAreaFull('section_10.' + index + '.miscReason', '', formik.values.section_10[index].miscReason)}
                              </td>
                              <td style={{ ...cellStyleW, minWidth: "100px" }}>
                                {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForreConstructionShedule(index)} />) : null}

                                {preConstructionShedule.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForPreConstructionShedule()} />) : null}
                              </td>

                            </td>
                          </tr>

                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </AccordionTab>

            </Accordion>
          </div>
        </form>
      )}
    </>
  );
};

export default EDIT_INTERIOR_DESIGN_TEMPLATE